import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { APPOINTMENT_STATUS } from '../models/enums';

@Pipe({
  name: 'appointmentStatusFormatter',
  pure: false,
})
export class AppointmentStatusFormatterPipe implements PipeTransform {
  constructor(private translateService: TranslateService) {}

  transform(value: APPOINTMENT_STATUS, ...args: any[]): any {
    if (!value) {
      return value;
    }

    let resultDate = this.getResult(value);

    this.translateService.onLangChange.subscribe(() => {
      resultDate = this.getResult(value);
    });

    return resultDate;
  }

  private getResult(status: APPOINTMENT_STATUS): string {
    return this.translateService.instant(`pipes.appointment_status.${status}`);
  }
}
